import { httpClient } from "@/services";

export default {
	state: {
		settingsOffice: [],
		officeOffice: [],
		filtersOffice: {},
		editOffice: {},
	},
	mutations: {
		updateOffice(state, { settings, items, filters }) {
			state.settingsOffice = settings;
			state.officeOffice = items;
			state.filtersOffice = filters;
		},
		updateEditOffice(state, { department }) {
			state.editOffice = department;
		},
	},
	actions: {

		async deleteAccountOffice({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/info/offices/${ id }`);
				if (data && data.status) {
					dispatch('getAccountOfficeList', true);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getAccountOfficeList({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get("/info/offices");
				if (data) {
					commit('updateOffice', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		async onAccountOfficeEdit({ commit, dispatch }, args ) {
			try {
				const { id, sendInfo2 } = args;
				const { data } = await httpClient.put(`/info/offices/${ id }`, sendInfo2);
				if ( data ) {
					commit('updateAccountSettings', data);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

		async onAccountOfficeSave({ commit, dispatch }, args ) {
			// dispatch("actionPreloader", true);
			try {
				const { sendInfo2 } = args;

				const { data } = await httpClient.post("/info/offices", sendInfo2);

				if ( data ) {
					commit('updateAccountSettings', data);
					// dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

		async getAccountOfficeEdit({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/info/offices/${ id }/edit`);

				if (data && data.status) {
					commit('updateEditOffice', data);
					dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},
		// onDefaultList({ commit }) {
		// 	commit('updateDefaultList');
		// }
	},
	getters: {
		editOffice: s => s.editOffice,
		settingsOffice: s => s.settingsOffice,
		officeOffice: s => s.officeOffice,
		filtersOffice: s => s.filtersOffice,
	},
};
